import { emptyPriceInformation, PriceInformation, ProductType } from "./paymentTypes";
import create from "zustand";
import defaultPaymentInfoServiceInstance from "../../../provider/paymentInfoService";
import usePaymentCheckoutState from "./paymentCheckoutState";
import useAuthState from "../../authState";

type DiscountType = "none"|"upgrade"|"customAboPrice"|"discount";

interface PaymentCheckoutAboBasicState {

    priceInformation: PriceInformation,
    calculate: () => void;

    product: ProductType;
    setProduct: (product: ProductType) => void;

    discountType: DiscountType

}

export const usePaymentCheckoutAboBasicState = create<PaymentCheckoutAboBasicState>(
    (set, get) => (
        {
            discountType: "none",

            priceInformation: emptyPriceInformation,
            calculate: () => {

                const isGiftcard = usePaymentCheckoutState.getState().isGiftcard;
                const product = get().product;

                const currentUserOverview = useAuthState.getState().currentUserOverview;

                // calculate price
                let priceInformation: PriceInformation = emptyPriceInformation;

                // discount prio 1 - upgrade price (from course buy)
                if (currentUserOverview?.upgradePriceReduction > 0 && !isGiftcard) {

                    const priceInformation: PriceInformation = {
                        startPrice: product?.price,
                        totalPrice: product?.price - currentUserOverview.upgradePriceReduction,
                        discountPrice: currentUserOverview.upgradePriceReduction,
                        discountPercentage: product?.price ? Math.round(product.price / currentUserOverview.upgradePriceReduction) : 0,
                        voucherTag: "upgrade",
                        voucherStatus: null
                    };

                    set({ priceInformation, discountType: "upgrade" } );

                } else if ( (currentUserOverview?.customAboPrice > 0 && currentUserOverview.customAboPrice < product?.price) && !isGiftcard) {

                    priceInformation = {
                        startPrice: product?.priceBefore,
                        totalPrice: currentUserOverview.customAboPrice,
                        discountPrice: product?.priceBefore - currentUserOverview.customAboPrice,
                        discountPercentage: product?.priceBefore ? Math.round(product.priceBefore / currentUserOverview.customAboPrice) : 0,
                        voucherTag: "customAboPrice",
                        voucherCode: null,
                        voucherStatus: null
                    };

                    set( { priceInformation, discountType: "customAboPrice" })

                } else {

                    const calculatedPriceInformation: PriceInformation =
                        defaultPaymentInfoServiceInstance.calculatePriceForProduct(product, undefined, isGiftcard);

                    if (calculatedPriceInformation?.discountPrice <= 0) {
                        priceInformation = {
                            startPrice: product?.priceBefore,
                            totalPrice: product?.price,
                            discountPrice: product?.priceBefore - product?.price,
                            discountPercentage: product?.priceBefore ? Math.round(product.priceBefore / (product.priceBefore - product.price)) : 0,
                            voucherTag: calculatedPriceInformation.voucherTag,
                            voucherStatus: calculatedPriceInformation.voucherStatus,
                            voucherCode: calculatedPriceInformation.voucherCode
                        }

                        set( { priceInformation, discountType: "none" } );
                    } else {
                        const discountPrice = product?.priceBefore - calculatedPriceInformation?.totalPrice;

                        priceInformation = {
                            startPrice: product?.priceBefore,
                            totalPrice: calculatedPriceInformation?.totalPrice,
                            discountPrice,
                            discountPercentage: product?.priceBefore ? Math.round(product.priceBefore / discountPrice) : 0,
                            voucherTag: calculatedPriceInformation?.voucherTag,
                            voucherStatus: calculatedPriceInformation?.voucherStatus,
                            voucherCode: calculatedPriceInformation?.voucherCode
                        }

                        set( { priceInformation, discountType: "discount" } );
                    }

                }

            },

            product: null,
            setProduct: (product) => {
                set( { product } );
                get().calculate();
            }
        }
    )
);

useAuthState.subscribe(
    (state) => {
        if (state.currentUserOverview) {
            usePaymentCheckoutAboBasicState.getState().calculate();
        }
    }
);
